import * as UserExplorerActions from '../actions/userExplorer';
import userExplorerCurrentCategory$ from '../selectors/userExplorerCurrentCategory';

import ReduxAction from '../interfaces/ReduxAction';

export function userExplorerFilter (value: string, checked: boolean): ReduxAction {
  return (dispatch, getState): void => {
    if (userExplorerCurrentCategory$(getState()).All && value !== 'All') {
      dispatch(UserExplorerActions
        .fetchUserExplorerChangeCategoryAction('All', !userExplorerCurrentCategory$(getState()).All));
      dispatch(UserExplorerActions.fetchUserExplorerChangeCategoryAction(value, !checked));
    } else {
      dispatch(UserExplorerActions.fetchUserExplorerChangeCategoryAction(value, checked));
    }
  };
}
